import PropTypes from "prop-types"

const InfoLayout = ({ children, heading, layout, title }) => {
  return (
    <>
      {layout && (
        <div className="tablet:px-16 contained mt-32 px-10">
          <h1 className="text-26 mb-16 text-center font-light capitalize tracking-wide">
            {heading || title}
          </h1>
        </div>
      )}
      {children}
    </>
  )
}

InfoLayout.propTypes = {
  children: PropTypes.element.isRequired,
  heading: PropTypes.string,
  layout: PropTypes.string,
  title: PropTypes.string,
}

export default InfoLayout
